export const amountFilter = [
  { id: 1, label: '$0 - $19,999', bt: '0,20000' },
  {
    id: 2,
    label: '$20,000 - $39,999',
    bt: '20000,40000',
  },
  {
    id: 3,
    label: '$40,000 - $59,999',
    bt: '40000,60000',
  },
  {
    id: 4,
    label: '$60,000 - $79,999',
    bt: '60000,80000',
  },
  {
    id: 5,
    label: '$80,000 - $99,999',
    bt: '80000,100000',
  },
  { id: 6, label: '$100,000+', gte: 100000 },
];

// for MCustomNumberInput
export const intNumRegex = /^\d*$/;
export const intNumWithNegativeRegex = /^[-]?\d*$/;
export const decimalRegex = /^\d+\.?\d*$/;
export const decimalWithNegativeRegex = /^[-]?\d+\.?\d*$/;
// when addition is enabled
export const hasAdditionRegex = /^[0-9]*\++[0-9]*$/;
export const additionRegex = /^\+?[0-9]+$/;
export const specialCharacterRegex = /[^\w\s]/gi;
export const SAFE_FILENAME = /[/?<>\\:*|"]/g;
export const NOT_NUMERIC = /[^0-9]/g;

// Usage event custom-property names / field paths must be a direct identifier —
// letters, digits, and underscores, starting with a letter (no dots). Enforced
// server-side by the usage service when it builds the underlying Timestream query.
export const USAGE_EVENT_FIELD_PATTERN = /^[a-zA-Z][a-zA-Z0-9_]*$/;
export const isValidUsageEventField = (value: string): boolean =>
  USAGE_EVENT_FIELD_PATTERN.test(value);

// Property names the usage service reserves for its own columns. Rejected
// (case-insensitively) on ingest, so a custom field with one of these keys could
// never receive a value.
export const USAGE_EVENT_RESERVED_PROPERTY_KEYS: ReadonlySet<string> = new Set([
  'id',
  'account_id',
  'subscription_id',
  'usage_type_id',
  'tenant_id',
  'units_consumed',
  'rated_price',
  'time',
  'measure_name',
]);
export const isReservedUsageEventField = (value: string): boolean =>
  USAGE_EVENT_RESERVED_PROPERTY_KEYS.has(value.trim().toLowerCase());

// The usage service rejects an event carrying more properties than this.
export const USAGE_EVENT_MAX_PROPERTIES_PER_EVENT = 20;

export const ISO_COMPATIBLE_DATE =
  /[0-9]{4}-[0-9]{2}-[0-9]{2}($|T[0-9]{2}| [0-9]{2}(\+[0-9]{2}:[0-9]{2}|z|-[0-9]{4}|:[0-9]{2}:[0-9]{2}\.[0-9]{3}\+[0-9]{2}($|:[0-9]{2})|$|:[0-9]{2}($|:[0-9]{2}($|.[0-9]{3}))))/;

export const TWENTY_FOUR_HR_TIME = /^[0-9]{1,2}:[0-9]{1,2}:[0-9]{1,2}$/;
export const TWELVE_HR_TIME = /^[0-9]{1,2}:[0-9]{1,2} (A|P)M$/;

export enum DateFormatEnum {
  MM_DD_YYYY = 'MM_DD_YYYY',
  DD_MM_YYYY = 'DD_MM_YYYY',
  YYYY_MM_DD = 'YYYY_MM_DD',
}

export const EU_COUNTRY_NAMES = [
  'AT', // Austria
  'BE', // Belgium
  'BG', // Bulgaria
  'HR', // Croatia
  'CY', // Cyprus
  'CZ', // Czechia
  'DK', // Denmark
  'EE', // Estonia
  'FI', // Finland
  'FR', // France
  'DE', // Germany
  'GR', // Greece
  'HU', // Hungary
  'IE', // Ireland
  'IT', // Italy
  'LV', // Latvia
  'LT', // Lithuania
  'LU', // Luxembourg
  'MT', // Malta
  'NL', // Netherlands
  'PL', // Poland
  'PT', // Portugal
  'RO', // Romania
  'SK', // Slovakia
  'SI', // Slovenia
  'ES', // Spain
  'SE', // Sweden
  'Austria',
  'Belgium',
  'Bulgaria',
  'Croatia',
  'Cyprus',
  'Czech Republic',
  'Denmark',
  'Estonia',
  'Finland',
  'France',
  'Germany',
  'Greece',
  'Hungary',
  'Ireland',
  'Italy',
  'Latvia',
  'Lithuania',
  'Luxembourg',
  'Malta',
  'Netherlands',
  'Poland',
  'Portugal',
  'Romania',
  'Slovakia',
  'Slovenia',
  'Spain',
  'Sweden',
];

export const VAT_COUNTRY_NAMES = [...EU_COUNTRY_NAMES, 'GB', 'United Kingdom'];
